* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

#details-section {
  max-width: 820px;
  padding-left: var(--spacer);

  .details-header-section {
    display: flex;
    margin-bottom: calc(var(--spacer) * 2);
    align-items: center;
    column-gap: calc(8 * var(--spacer));

    .card-logo-container {
      height: 72px;
      width: 72px;
      background: var(--white-layout-201-secondary-on-dark-background);
      border-radius: 50%;
    }

    #integration-description {
      padding-left: 0;
      color: var(--main-titles-inputs-600);
    }
  }
}

gz-input-number {
  margin-bottom: 5px;
  display: inline-block;
}

.custom-space {
  padding-left: calc(var(--spacer) * 3.3);
  margin: var(--spacer) 0;
  color: var(--grey-layout-500-neutral-background);
}

.subsection-title {
  padding: var(--spacer) 0;
  margin-bottom: var(--spacer);
  color: var(--chart-302-icon-buttons-titles);
  text-transform: uppercase;
}

.time-container {
  display: flex;
  flex-direction: column;
  padding-left: calc(var(--spacer) * 3.3);
}

.retry-interval-container,
.max-tries-container {
  display: flex;
  align-items: center;
  margin-bottom: var(--spacer);

  gz-text {
    max-width: 225px;
  }
  gz-input-number {
    margin-bottom: 0;
  }
}

#view-type {
  margin: calc(var(--spacer) * 3) 0 calc(var(--spacer) * 3) 0;

  #view-type-description {
    margin-bottom: calc(var(--spacer) * 2);
    color: var(--main-titles-inputs-600);
  }
  gz-radio {
    height: calc(4 * var(--spacer));
    display: flex;
  }
}
